import { t } from "@/i18n-js/instance";
import { usePunditUserContext } from "@circle-react/contexts";
import { dateStringToTimeAgo } from "@circle-react/helpers/dateTimeHelpers/timeAgo";
import { Typography } from "@circle-react-uikit/Typography";
import { WarningWrapper } from "./WarningWrapper";

export const SpecialOffer = () => {
  const { currentCommunity } = usePunditUserContext();

  return (
    <WarningWrapper>
      <Typography.LabelLg weight="semibold">
        {t("pricing_plans.banner.title")}
      </Typography.LabelLg>
      <Typography.BodyMd color="text-default">
        {t("pricing_plans.banner.subtitle", {
          expires_in: dateStringToTimeAgo(
            currentCommunity?.trial_ends_at || "",
          ),
        })}
      </Typography.BodyMd>
    </WarningWrapper>
  );
};
